import React from "react";
import { BugReport, FactCheck, Science } from "@mui/icons-material";
import { workItemTypes } from "../../../../data/workspaceData";
import { EmptyActionBar, SectionHeader } from "../../common/WorkspaceChrome";
import { WorkBoard } from "../tasks-tickets/WorkBoard";

export function MyWorkView({ workView, setWorkView, moduleName = "My Work" }) {
  return (
    <>
      <section className="module-header-card">
        <SectionHeader
          eyebrow={moduleName}
          title={
            moduleName === "Tasks & Tickets"
              ? "Jira/Trello-style board for tasks, tickets, bugs, backlog, and templates"
              : "Personal workspace for assigned tasks, tickets, projects, meetings, attendance, leaves, docs, and wallet"
          }
          text={
            moduleName === "Tasks & Tickets"
              ? "A shared work tracking area with board, list, backlog, tickets, bugs, overdue work, and reusable templates."
              : "Shows only work related to the logged-in user."
          }
        />
        <EmptyActionBar primary="Create task" secondary="Add filter" />
      </section>
      <WorkBoard workView={workView} setWorkView={setWorkView} />
      <section className="panel">
        <SectionHeader
          eyebrow="Work Item Types"
          title="Everything a company needs to track"
          text="The same system supports software teams, agencies, HR teams, trainers, sales teams, and client service teams."
        />
        <div className="work-type-grid">
          {workItemTypes.map((item) => {
            const Icon = item.type === "Bug" ? BugReport : item.type === "Test" ? Science : FactCheck;
            return (
              <article className="work-type-card" key={item.type}>
                <Icon fontSize="small" />
                <h3>{item.type}</h3>
                <p>{item.description}</p>
                <div className="chip-row">
                  {item.examples.map((example) => (
                    <span key={example}>{example}</span>
                  ))}
                </div>
              </article>
            );
          })}
        </div>
      </section>
    </>
  );
}
